var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510.001 510.001",
    height: 512,
    viewBox: "0 0 510.001 510.001",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.772,
    x2: 258.772,
    xlinkHref: "#lg1",
    y1: 234.427,
    y2: 471.872
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.021,
    x2: 322.335,
    y1: 106.432,
    y2: 369.727
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb37e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1704,
    stopColor: "#f0aa76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4808,
    stopColor: "#cf9362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8934,
    stopColor: "#9b6d42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c6239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 418.731,
    y2: 253.168
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.026,
    x2: 550.581,
    xlinkHref: "#lg2",
    y1: 218.435,
    y2: 231.117
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.819,
    x2: 273.561,
    xlinkHref: "#lg2",
    y1: 274.137,
    y2: 137.879
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 148.067,
    x2: 445.148,
    y1: 97.307,
    y2: 192.292
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb37e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6265,
    stopColor: "#b78154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.662,
    x2: 267.859,
    xlinkHref: "#lg2",
    y1: 12.478,
    y2: 78.545
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 311.106,
    x2: 158.315,
    xlinkHref: "#lg2",
    y1: 173.194,
    y2: 664.007
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.493,
    x2: 420.041,
    xlinkHref: "#lg2",
    y1: 118.928,
    y2: 392.421
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.595,
    x2: 319.449,
    y1: 215.052,
    y2: 222.35
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.45,
    x2: 330.45,
    y1: 198.423,
    y2: 416.174
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(1 -.004 -.004 -1 1709.059 541.987)",
    gradientUnits: "userSpaceOnUse",
    x1: -1416.044,
    x2: -1401.348,
    xlinkHref: "#lg1",
    y1: 59.373,
    y2: 97.809
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e566e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5262,
    stopColor: "#554156",
    stopOpacity: 0.526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433244"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(1 -.004 -.004 -1 1709.059 541.987)",
    gradientUnits: "userSpaceOnUse",
    x1: -1411.269,
    x2: -1445.606,
    xlinkHref: "#lg3",
    y1: 78.971,
    y2: 62.438
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(1 0 0 -1 0 856.101)",
    gradientUnits: "userSpaceOnUse",
    x1: 213.268,
    x2: 221.287,
    xlinkHref: "#lg1",
    y1: 364.799,
    y2: 417.446
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(-1 -.004 .004 -1 -2138.378 541.987)",
    gradientUnits: "userSpaceOnUse",
    x1: -2350.572,
    x2: -2384.91,
    xlinkHref: "#lg3",
    y1: 82.822,
    y2: 66.289
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(.844 -.537 .537 .844 -142.57 -54.557)",
    gradientUnits: "userSpaceOnUse",
    x1: 57.365,
    x2: 58.765,
    xlinkHref: "#lg1",
    y1: 639.831,
    y2: 666.334
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(.844 -.537 .537 .844 -142.57 -54.557)",
    gradientUnits: "userSpaceOnUse",
    x1: 57.867,
    x2: 57.867,
    y1: 652.967,
    y2: 622.981
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d8b91"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(1 -.014 .014 1 2342.964 -337.576)",
    gradientUnits: "userSpaceOnUse",
    x1: -2098.609,
    x2: -2075.983,
    xlinkHref: "#lg3",
    y1: 776.021,
    y2: 733.939
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m258.772 471.872c-50.235 0-97.336-23.944-132.626-67.422-34.804-42.88-53.972-99.77-53.972-160.19 0-5.43 4.402-9.833 9.833-9.833s9.833 4.402 9.833 9.833c0 114.663 74.885 207.947 166.932 207.947s166.932-93.285 166.932-207.947c0-5.43 4.402-9.833 9.833-9.833s9.833 4.402 9.833 9.833c0 60.421-19.167 117.31-53.972 160.19-35.289 43.478-82.39 67.422-132.626 67.422z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m496.684 114.261c-24.686-15.917-71.008 12.025-94.754 20.723-47.525 17.409-96.78 28.464-146.916 28.464-50.142 0-99.387-11.054-146.916-28.465-23.449-8.59-70.159-36.797-94.754-20.723-34.15 22.318 6.173 88.999 21.974 109.676 51.78 67.755 137.704 101.934 219.696 101.934 81.991 0 167.917-34.18 219.696-101.933 15.849-20.737 56.041-87.711 21.974-109.676z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m474.71 213.287c-51.779 67.753-137.705 101.933-219.696 101.933-81.992 0-167.916-34.178-219.697-101.933-10.628-13.907-32.347-48.626-35.04-76.661-3.207 29.194 23.014 71.574 35.041 87.31 51.78 67.755 137.704 101.933 219.697 101.933 81.99 0 167.917-34.18 219.696-101.933 12.061-15.782 38.216-58.341 35.012-87.463-2.69 28.016-24.355 62.869-35.013 76.814z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.684 114.261c-9.464-6.102-22.109-5.754-35.442-2.52 2.789 29.103-23.092 71.195-35.072 86.87-51.779 67.753-137.706 101.933-219.696 101.933-37.597 0-76.012-7.208-111.592-21.523 47.304 31.156 104.612 46.849 160.132 46.849 81.99 0 167.917-34.18 219.696-101.933 15.849-20.737 56.041-87.711 21.974-109.676z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m497.62 185.884c-7.59 15.98-16.96 30.27-22.91 38.05-51.78 67.76-137.7 101.94-219.7 101.94-14.73 0-29.59-1.1-44.35-3.31l-97.14-97.14c-8.01-6.95-11.38-18.04-8.27-28.44l17.08-57c43.1 14.5 87.53 23.46 132.68 23.46 50.14 0 99.39-11.05 146.92-28.46 11.7-4.28 28.88-13.24 46.25-19.32 17.89-6.26 35.98-9.48 48.5-1.4 21.29 13.72 13.59 45.01.94 71.62z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m300.689 3.116-3.829 1.606c-26.777 11.233-56.944 11.233-83.721 0l-3.829-1.606c-21.81-9.149-46.74 2.624-53.53 25.28l-50.53 168.593c-3.503 11.689 1.184 24.283 11.476 30.837l13.985 8.906c75.824 48.286 172.752 48.286 248.576 0l13.985-8.906c10.293-6.555 14.98-19.148 11.476-30.837l-50.528-168.593c-6.79-22.656-31.72-34.429-53.531-25.28z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.184 8.883c0-3.009-.482-5.944-1.388-8.777-5.981-.413-12.159.515-18.107 3.01l-3.829 1.606c-26.777 11.233-56.944 11.233-83.721 0l-3.829-1.606c-5.948-2.495-12.126-3.424-18.107-3.01-.906 2.833-1.388 5.768-1.388 8.777.001 23.559 29.185 42.657 65.185 42.657s65.184-19.098 65.184-42.657z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.288 236.732 13.985-8.906c10.293-6.555 14.98-19.148 11.476-30.837l-50.529-168.593c-6.79-22.656-31.72-34.43-53.531-25.28l-3.829 1.606c-13.388 5.616-27.625 8.425-41.861 8.425v259.8c43.189 0 86.377-12.072 124.289-36.215z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.75 196.989-50.53-168.593c-6.045-20.169-26.464-31.699-46.262-27.536.054.172.117.34.169.513l36.431 121.238c12.656 42.119-7.402 87.373-47.357 105.753-.797.366-1.508.676-2.124.924-58.412 23.446-124.165 22.104-181.738-4.021 1.051.927 2.177 1.788 3.388 2.559l13.985 8.906c75.824 48.286 172.752 48.286 248.576 0l13.985-8.906c10.293-6.554 14.98-19.148 11.477-30.837z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m397.912 174.175c-.587-1.959-2.879-2.759-4.602-1.658-.012.008-.024.015-.036.023l-13.985 8.906c-75.824 48.286-172.752 48.286-248.576 0l-13.985-8.906c-.012-.008-.024-.015-.036-.023-1.723-1.102-4.015-.301-4.603 1.658l-6.838 22.814c-3.503 11.689 1.184 24.282 11.476 30.837l13.985 8.906c75.824 48.286 172.752 48.286 248.576 0l13.985-8.906c10.293-6.555 14.98-19.148 11.476-30.837z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m396.656 169.985c-1.05.925-2.174 1.785-3.383 2.555l-13.985 8.906c-37.912 24.143-81.1 36.206-124.288 36.206v55.295c43.188 0 86.376-12.071 124.288-36.214l13.985-8.906c10.293-6.555 14.98-19.148 11.476-30.837z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256.228 469.134 11.103 21.201c6.356 12.138 18.947 19.721 32.647 19.665l25.013-.102c8.376-.034 13.399-9.318 8.846-16.348l-10.816-16.698c-5.268-8.133-13.539-13.851-23.009-15.906l-32.218-6.993c-8.734-1.896-15.712 7.263-11.566 15.181z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.248 487.539c-22.157.09-42.145-9.245-56.195-24.224.537-5.899 6.131-10.798 12.742-9.363l32.218 6.993c9.469 2.055 17.741 7.773 23.009 15.906l5.582 8.617c-5.577 1.317-11.381 2.047-17.356 2.071z",
    fill: "url(#SVGID_13_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m253.772 469.134-11.103 21.201c-6.356 12.138-18.947 19.721-32.648 19.665l-25.013-.102c-8.376-.034-13.4-9.318-8.846-16.348l10.816-16.698c5.268-8.133 13.54-13.851 23.009-15.906l32.218-6.993c8.735-1.896 15.713 7.263 11.567 15.181z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.752 487.539c22.157.09 42.145-9.245 56.195-24.224-.537-5.899-6.131-10.798-12.742-9.363l-32.218 6.993c-9.469 2.055-17.741 7.773-23.009 15.906l-5.582 8.617c5.577 1.317 11.381 2.047 17.356 2.071z",
    fill: "url(#SVGID_15_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m271.462 461.843c.13 9.09-7.135 16.564-16.227 16.694s-16.567-7.134-16.697-16.224 7.135-16.564 16.227-16.693c9.092-.131 16.567 7.133 16.697 16.223z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.739 461.881c.108 7.586-5.955 13.824-13.543 13.932s-13.827-5.954-13.935-13.54 5.955-13.824 13.543-13.932 13.827 5.954 13.935 13.54z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.154 447.25c1.142 2.2 1.803 4.691 1.841 7.338.13 9.09-7.135 16.564-16.227 16.693-2.647.038-5.157-.552-7.389-1.631 2.78 5.355 8.411 8.978 14.855 8.886 9.092-.13 16.357-7.604 16.227-16.694-.091-6.442-3.874-11.967-9.307-14.592z",
    fill: "url(#SVGID_18_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHat);
export default __webpack_public_path__ + "static/media/icon-hat.f113f6b328b903200b1ce62d8bbae574.svg";
export { ForwardRef as ReactComponent };